
export const trainColor = "#2D3142";
export const testColor = "#cd0e66";
export const validationColor = "#fbbf24";